import { Component, OnInit } from '@angular/core';
import { ClienteExpressService } from 'src/app/core/services/cliente-express.service';

@Component({
  selector: 'app-register-express-retail',
  templateUrl: './register-express-retail.component.html',
  styleUrls: ['./register-express-retail.component.scss']
})
export class RegisterExpressRetailComponent implements OnInit {

  public isLoading = false;
  public showMessage = true;

  public comunas: any[];

  constructor(
    private clienteExpressService: ClienteExpressService
  ) { }

  ngOnInit(): void {
    this.getComunas();
  }


  private async getComunas() {
    try {
      this.isLoading = true;
      const resp = await this.clienteExpressService.getComunas();
      this.comunas = resp.comunasValidas;
      console.log('🚀 ~ RegisterExpressRetailComponent ~ getComunas ~ resp:', resp);
    } catch (error) {
      console.error('Error al leer las comunas disponibles');
    } finally {
      this.isLoading = false;
    }
  }

  public toogleMessage() {
    this.showMessage = !this.showMessage;
  }

}
